import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Callout',
    defaultMessage: 'Callout',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  text: {
    id: 'Text',
    defaultMessage: 'Text',
  },
  variant: {
    id: 'Variant',
    defaultMessage: 'Variant',
  },
  variantSideBorder: {
    id: 'Side Border',
    defaultMessage: 'Side Border',
  },
  variantQuote: {
    id: 'Quote',
    defaultMessage: 'Quote',
  },
  citation: {
    id: 'Citation',
    defaultMessage: 'Citation',
  },
});

const CalloutSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['text', 'variant', 'citation'],
    },
  ],
  properties: {
    text: {
      title: intl.formatMessage(messages.text),
      type: 'string',
      widget: 'textarea',
    },
    variant: {
      title: intl.formatMessage(messages.variant),
      type: 'string',
      choices: [
        ['sideBorder', intl.formatMessage(messages.variantSideBorder)],
        ['quote', intl.formatMessage(messages.variantQuote)],
      ],
      default: 'sideBorder',
    },
    citation: {
      title: intl.formatMessage(messages.citation),
      type: 'string',
    },
  },
  required: [],
});

export default CalloutSchema;
